import React from "react"
import Newsletter from "../Shared/Newsletter"
import classes from "./Footer.module.scss"
import logoGL from "../../assets/images/logo-gl.png"
import logoVG from "../../assets/images/logo-vg.png"
import logoYo from "../../assets/images/logo-yoho.png"

const footer = () => {
  return (
    <div className={classes.Footer}>
      <div className={[classes.sectionWrap, classes.inside12, classes.flexGroup].join(' ')}>
        <div className={[classes.footBlock, classes.family, classes.flexGroup].join(' ')}>
          <h3>Visit Our Other Amazing Restaurants</h3>
          <a href="http://ginnylanebargrill.com/" target="_blank" rel="noopener noreferrer" className={[classes.logo, classes.gl, classes.wide].join(' ')}><img src={logoGL} alt="Ginny Lane Logo" /></a>
          <a href="https://www.yohorumandtacos.com/" target="_blank" rel="noopener noreferrer" className={[classes.logo, classes.yoho, classes.tall].join(' ')}><img src={logoYo} alt="Yoho Rum and Tacos Logo" /></a>
          <a href="http://villaggiogrille.com/" target="_blank" rel="noopener noreferrer" className={[classes.logo, classes.vg, classes.wide].join(' ')}><img src={logoVG} alt="Villaggio Grille Logo" /></a>
        </div>
        
        <div className={[classes.footBlock, classes.mailer].join(' ')}>
          <Newsletter where="footer" />
        </div>
      </div>

      <div className={classes.copyHs}>
        <div className={[classes.copyWrap, classes.insideXl, classes.flexGroup].join(' ')}>
          <p className={classes.copy}>© {(new Date().getFullYear())} Mile Marker 158 Dockside. All rights reserved.</p> 
          <p className={classes.hs}>Design by <a href="http://hsdesignhouse.com" target="_blank" rel="noopener noreferrer">High Seas Design House.</a></p>
        </div>
      </div>
    </div>
  )
}

export default footer